<template>
    <layout v-bind:user="loginUser" v-bind:company="company" v-bind:brands="brands" v-bind:shops="shops">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <section>
                <!-- ここから -->

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    Heading
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <h1 class="heading_page-title flex _y-center">
                    <div class="main"><span>メンバー招待</span></div>
                </h1><!--/.heading_page-title-->

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    TeamInvitation
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <div class="team_component form_admin-container">

                    <div class="md_common-bl _padding-add">
                        <div class="inner">

                            <!-- Title -->
                            <div class="md_common-bl-title-wrap">
                                <h3 class="title"><span class="md_text-bold _link-color">{{ companyName }}</span>にメンバーを招待</h3>
                                <p>招待するメンバーの権限を選択してください。</p>
                            </div>

                            <!-- InputGroup -->
                            <div class="input-group">

                                <!-- RadioItem -->
                                <div class="form_item-text form_radio-text">
                                    <input type="radio" name="invitation-radio1" id="invitation-radio1-1" value="0" v-bind:disabled="managerNum >= 2" v-model="selectedRole">
                                    <label for="invitation-radio1-1">
                                        <div class="mark"></div>
                                        <span v-if="managerNum >= 2">{{ roleLists[0].name }}  ※管理者の人数が上限に達しているため選択できません</span>
                                        <span v-if="managerNum < 2">{{ roleLists[0].name }}</span>
                                        <p class="sup">最上位の権限です。メンバーの招待、プランのアップグレード等全ての操作を行えます。※ 管理者は運営会社に2名です。管理者の管理画面より権限の譲渡が可能です。</p>
                                    </label>
                                </div>

                                <!-- RadioItem -->
                                <div class="form_item-text form_radio-text">
                                    <input type="radio" name="invitation-radio1" id="invitation-radio1-2" value="1" v-model="selectedRole">
                                    <label for="invitation-radio1-2">
                                        <div class="mark"></div>
                                        <span>{{ roleLists[1].name }}</span>
                                        <p class="sup">基本的な操作が可能です。無料{{ userType }}の追加を行えます。</p>
                                    </label>
                                </div>

                            </div><!--/.input-group-->

                            <!-- InputGroup -->
                            <div class="input-group">

                                <!-- メールアドレス -->
                                <div class="form_item-text form_text">
                                    <div class="input-row">
                                        <input type="email" id="invitation-email" inputmode="email" v-model="inputEmail">
                                    </div>
                                    <label for="invitation-email">
                                        <span>メールアドレス</span>
                                    </label>
                                    <p class="sup">招待するメンバーのメールアドレスを入力してください。</p>
                                </div>

                            </div><!--/.input-group-->

                            <!-- BtnLinkWrap -->
                            <div class="btn_link-wrap">

                                <!--LinkBtn - キャンセル -->
                                <Link class="btn_link _cancel md_icon-text" :href="route(cancelRoute)" as="button">
                                        <div class="inner">
                                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                        </div>
                                </Link>

                                <!--LinkBtn - 決定アイコン -->
                                <button class="btn_link md_icon-text _white" v-on:click="sendInvitationMail" v-bind:disabled="isInValidEmail">
                                    <div class="inner">
                                        <span><div class="icon"><SvgIconCheck /></div>招待を送信する</span>
                                    </div>
                                </button>

                            </div><!-- /BtnLinkWrap -->

                        </div>
                    </div>

                </div><!-- /.team_component -->

                <!-- ここまで -->
            </section>
            <AlertModal 
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Link } from '@inertiajs/inertia-vue3'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'


    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "AlertModal": AlertModal,
            //Svg
            SvgIconEdit,
            SvgIconCancel,
            SvgIconCheck,
            SvgIconSend,

        },
        data() {
            return {
                roleLists: [
                    {role: 0, name: '管理者'},
                    {role: 1, name: '一般'}
                ],
                selectedRole: '',
                inputEmail: '',
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        props: {
            loginUser: Object,
            employees: Object,
            company: Object,
            brands: Object,
            shops: Object,
        },
        methods: {
            sendInvitationMail() {
                var routeName = '';
                if (this.loginUser.type == 1) {
                    routeName = 'admin.shop.send.invitation';
                } else if (this.loginUser.type == 2) {
                    routeName = 'admin.brand.send.invitation';
                } else if (this.loginUser.type == 3) {
                    routeName = 'admin.showroom.send.invitation';
                }
                const data = reactive({
                    selected_role: this.selectedRole,
                    email: this.inputEmail,
                })
                Inertia.post(route(routeName), data, {
                    preserveScroll: true,
                    onError: (errors) => {
                        this.selectedRole = '';
                        if (errors.selected_role) {
                            this.openAlertModal('error', 'エラー', errors.selected_role); // 確認済み
                        }
                        if (errors.email) {
                            this.openAlertModal('error','エラー', errors.email); // 確認済み
                        }
                    },
                    onSuccess: visit => {
                        this.selectedRole = '';
                        this.inputEmail = '';
                        this.openAlertModal('success', '送信完了', 'ご入力頂いたメールアドレスへ招待メールを送信しました'); // 確認済み
                        window.reload();
                    },
                    onFinish: visit => {
                    },
                })
            },
            validEmail() {
                const reg = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/);
                return !reg.test(this.inputEmail);
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            }
        },
        computed: {
            managerNum() {
                var managerList = [];
                if(this.employees) {
                    this.employees.forEach(employee => {
                        if (employee.role  == 0) {
                            managerList.push(employee);
                        }
                    });
                    if (managerList) {
                        return managerList.length;
                    } else return null;
                } else return null;
            },
            companyName() {
                if(this.company) {
                    return this.company.name;
                } else return null;
            },
            userType() {
                if(this.loginUser) {
                    switch (this.loginUser.type) {
                        case 1:
                            return 'ショップ';
                            break;
                        case 2:
                            return 'ブランド';
                            break;
                        case 3:
                            return 'ショールーム';
                            break;
                        default:
                            return '';
                            break;
                    }
                } else return null;
            },
            cancelRoute() {
                if(this.loginUser) {
                    switch (this.loginUser.type) {
                        case 1:
                            return 'admin.shop.team.index';
                            break;
                        case 2:
                            return 'admin.brand.team.index';
                            break;
                        case 3:
                            return 'admin.showroom.team.index';
                            break;
                        default:
                            return '';
                            break;
                    }
                } else return null;
            },
            isInValidEmail() {
                return this.validEmail();
            },
            backName() {
                if (this.loginUser.type == 0) {
                    return 'Admin';
                } else if (this.loginUser.type == 1) {
                    return 'Shop';
                } else if (this.loginUser.type == 2) {
                    return 'Brand';
                } else if (this.loginUser.type == 3) {
                    return 'ShowRoom';
                }
            },
        },
    }
</script>
